"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Autocomplete_1 = __importStar(require("@material-ui/lab/Autocomplete"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../../lib");
const context_1 = __importDefault(require("../context"));
function filterDuplicates(options) {
    const uniqueSet = new Set();
    return options.filter((option) => {
        const key = option.name || option;
        if (uniqueSet.has(key))
            return false;
        return !!uniqueSet.add(key);
    });
}
const InputComboBox = ({ name, label, type, required = false, autoFocus = false, disabled = false, multiple = false, options: staticOptions, search, renderOption = (opt) => opt.label || opt, hasError, message, }) => {
    const { obj, updateProperty } = react_1.useContext(context_1.default);
    const [open, setOpen] = react_1.useState(false);
    const [loading, setLoading] = react_1.useState(false);
    const [inputValue, setInputValue] = react_1.useState('');
    const [options, setOptions] = react_1.useState(staticOptions || []);
    const debouncedSearch = react_1.useMemo(() => search &&
        lib_1.debounce((input, callback) => {
            search(input).then(callback);
        }, 200), [search]);
    const getOptionSelected = (option, value) => (option.name ? option.name === value.name : option === value);
    const multipleValue = multiple
        ? (lib_1.lett(lib_1.deepGet(obj, name, []), (names) => names.map((name) => options.find((opt) => opt.name === name || opt === name))) || []).filter((value) => options.some((opt) => opt.name === value || opt === value))
        : undefined;
    const simpleValue = !multiple
        ? lib_1.lett(lib_1.deepGet(obj, name, null), (name) => options.find((opt) => name === (opt.name || opt))) || null
        : undefined;
    react_1.useEffect(() => {
        let active = true;
        if (!debouncedSearch) {
            return undefined;
        }
        setLoading(true);
        debouncedSearch(inputValue, (results) => {
            setLoading(false);
            if (active) {
                setOptions((oldOptions) => filterDuplicates([
                    ...oldOptions.filter((option) => multiple
                        ? !!multipleValue.find((value) => getOptionSelected(option, value))
                        : simpleValue && getOptionSelected(option, simpleValue)),
                    ...results,
                ]));
            }
        });
        return () => {
            active = false;
        };
    }, [staticOptions, inputValue, debouncedSearch, setLoading]);
    return (react_1.default.createElement(FormControl_1.default, { disabled: disabled, error: hasError, required: required, fullWidth: true, margin: "dense" },
        react_1.default.createElement(Autocomplete_1.default, { value: multiple ? multipleValue : simpleValue, onChange: (_, newValue) => {
                updateProperty(name, type)(multiple
                    ? newValue.map((value) => value.name || value)
                    : newValue);
            }, open: open, multiple: multiple, disabled: disabled, onOpen: () => setOpen(true), onClose: () => {
                setOpen(false);
                setInputValue('');
            }, options: options, getOptionSelected: getOptionSelected, filterOptions: search ? (options) => options : Autocomplete_1.createFilterOptions(), getOptionLabel: (option) => option.label || option, inputValue: multiple ? inputValue : undefined, renderOption: renderOption, renderInput: (params) => (react_1.default.createElement(TextField_1.default, Object.assign({}, params, { onChange: (event) => setInputValue(event.target.value), name: name, label: label + (required ? ' *' : ''), margin: "dense", fullWidth: true, autoFocus: autoFocus, error: hasError, helperText: message, InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                        search && loading && open ? (react_1.default.createElement(CircularProgress_1.default, { color: "inherit", size: 20 })) : null,
                        params.InputProps.endAdornment)) }) }))) })));
};
exports.default = InputComboBox;
//# sourceMappingURL=ComboBox.js.map